// This helper is needed to convert non-iterable multilingual keys to the same shape, which can be passed via props
export var multilingualProp = function (multilingual) {
    if (!multilingual) {
        return null;
    }
    return {
        currentLanguage: multilingual.currentLanguage,
        isEnabled: multilingual.isEnabled,
        siteLanguages: multilingual.siteLanguages,
    };
};
//# sourceMappingURL=multilingualProp.js.map